// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// FULL RESCAN BASELINE FINDING SCHEMA
/////////////////////////////////////////

export const FullRescanBaselineFindingSchema = z.object({
  findingId: z.string(),
  key: z.string(),
})

export type FullRescanBaselineFinding = z.infer<typeof FullRescanBaselineFindingSchema>

export default FullRescanBaselineFindingSchema;
